import React from 'react';

const BusRatesTable = () => {
  const ratesData = [
    
    { seater: "SWIFT DESIRE", mumbai: "4+1 SEATER", mahabaleshwar: "12", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "AURA", mumbai: "4+1 SEATER", mahabaleshwar: "12", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "TOYOTA ETIOS", mumbai: "4+1 SEATER", mahabaleshwar: "14", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "ERITGA", mumbai: "6+1 SEATER", mahabaleshwar: "15", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "INNOVA", mumbai: "6+1 SEATER", mahabaleshwar: "18", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "SCORPIO", mumbai: "8+1 SEATER", mahabaleshwar: "18", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "INNOVA CRYSTA", mumbai: "6+1 SEATER", mahabaleshwar: "21", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "AUDI", mumbai: "4+1 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "TEMPO TRAVELLER", mumbai: "13/17 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "Urbania Van", mumbai: "13/17 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "MINI BUS", mumbai: "20 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "BUS", mumbai: "32-52 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "TAVERA", mumbai: "8+1 SEATER", mahabaleshwar: "18", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
    { seater: "KIA Carens", mumbai: "6+1/7+1 SEATER", mahabaleshwar: "17/KM & 18/KM", specialPermitNumber: "919594849797", driver: "Extra", parking: "Extra" },
  ];

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    margin: "20px auto",
  };

  const thStyle = {
    backgroundColor: "#FFCC00",
    color: "white",
    padding: "8px",
    border: "1px solid #ddd",
  };

  const tdStyle = {
    padding: "8px",
    border: "1px solid #ddd",
    textAlign: "center",
  };

  const trEvenStyle = {
    backgroundColor: "#f2f2f2",
  };

  const handleWhatsAppClick = (number, seater) => {
    console.log(`Opening WhatsApp for ${seater} with number ${number}`);
   const message = `Hello, I would like to book a ${seater} vehicle. Kindly share the availability, pricing, and booking details. Thank you.`;
    const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="container p-0">
      
      <div className="table-responsive">
        <table style={tableStyle}>
          <thead>
            <tr>
              <th className='borderrrrr' style={thStyle}>Bus Name</th>
              <th className='borderrrrr' style={thStyle}>Seater</th>
              <th className='borderrrrr' style={thStyle}>Per KM</th>
              <th className='borderrrrr' style={thStyle}>Driver Food</th>
              <th className='borderrrrr' style={thStyle}>Toll Parking</th>
              <th className='borderrrrr' style={thStyle}>Book Now</th>
            </tr>
          </thead>
          <tbody>
            {ratesData.map((row, index) => (
              <tr key={index} style={index % 2 === 0 ? trEvenStyle : null}>
                <td className='borderrrrr' style={tdStyle}>{row.seater}</td>
                <td className='borderrrrr' style={tdStyle}>{row.mumbai}</td>
                <td className='borderrrrr' style={tdStyle}>{row.mahabaleshwar}</td>
                <td className='borderrrrr' style={tdStyle}>{row.driver}</td>
                <td className='borderrrrr' style={tdStyle}>{row.parking}</td>
                <td className='borderrrrr' style={tdStyle}>
                  <button
                    onClick={() => handleWhatsAppClick(row.specialPermitNumber, row.seater)}
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#FFCC00",
                      padding: "10px",
                      borderRadius: "8px",
                      color: "white",
                    }}
                  >
                    Book Now
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>


    </div>
  );
};

export default BusRatesTable;
